export default "__VITE_ASSET__dfb738fc__"